const commonLabels = {
    data: require('../translations/common_labels')
}

export default commonLabels;